'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _map = require('babel-runtime/core-js/map');

var _map2 = _interopRequireDefault(_map);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _QueryNodeVisitor2 = require('../engine/QueryNodeVisitor');

var _QueryNodeVisitor3 = _interopRequireDefault(_QueryNodeVisitor2);

var _QueryNodeRegistry = require('../QueryNodeRegistry');

var _QueryNodeRegistry2 = _interopRequireDefault(_QueryNodeRegistry);

var _DocumentType = require('../predicates/DocumentType');

var _DocumentType2 = _interopRequireDefault(_DocumentType);

var _DocumentTypeList = require('../predicates/DocumentTypeList');

var _DocumentTypeList2 = _interopRequireDefault(_DocumentTypeList);

var _AndCondition = require('../conditions/AndCondition');

var _AndCondition2 = _interopRequireDefault(_AndCondition);

var _nodeEquivalence = require('./nodeEquivalence');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DocumentTypeOptimizerVisitor = function (_QueryNodeVisitor) {
    (0, _inherits3.default)(DocumentTypeOptimizerVisitor, _QueryNodeVisitor);

    function DocumentTypeOptimizerVisitor(queryNode) {
        (0, _classCallCheck3.default)(this, DocumentTypeOptimizerVisitor);

        var _this = (0, _possibleConstructorReturn3.default)(this, (DocumentTypeOptimizerVisitor.__proto__ || (0, _getPrototypeOf2.default)(DocumentTypeOptimizerVisitor)).call(this));

        _this.queryNode = queryNode;
        return _this;
    }

    (0, _createClass3.default)(DocumentTypeOptimizerVisitor, [{
        key: 'visitConditions',
        value: function visitConditions(context) {
            var conditions = _lodash2.default.get(this.queryNode, context.path, this.queryNode);
            var groupings = this.groupDocumentTypesByEquivalentChildren(conditions);

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                var _loop = function _loop() {
                    var _step$value = (0, _slicedToArray3.default)(_step.value, 2),
                        grouping = _step$value[0],
                        documentTypeNodes = _step$value[1];

                    if (_lodash2.default.isEmpty(grouping) || documentTypeNodes.length <= 1) {
                        return 'continue';
                    }
                    (0, _lodash2.default)(conditions.children).filter(function (child) {
                        return documentTypeNodes.includes(child);
                    }).forEach(function (child) {
                        return conditions.removeChild(child);
                    });
                    var documentTypes = _lodash2.default.map(documentTypeNodes, function (node) {
                        return _lodash2.default.clone(node.documentType);
                    });
                    var documentTypeList = new _DocumentTypeList2.default({ data: { documentTypes: documentTypes } });
                    var andCondition = new _AndCondition2.default(documentTypeList);
                    grouping.forEach(function (g) {
                        g.parentNode = andCondition;
                    });
                    conditions.addChild(andCondition);
                };

                for (var _iterator = (0, _getIterator3.default)(groupings), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var _ret = _loop();

                    if (_ret === 'continue') continue;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    }, {
        key: 'groupDocumentTypesByEquivalentChildren',
        value: function groupDocumentTypesByEquivalentChildren(conditions) {
            var remainingDocumentTypeNodes = (0, _lodash2.default)(conditions.children).filter(function (child) {
                return _QueryNodeRegistry2.default.hasAncestorWithName(child.type, _DocumentType2.default.name);
            }).value();
            var groupings = new _map2.default();

            var _loop2 = function _loop2() {
                var nextDocumentTypeNode = _lodash2.default.first(remainingDocumentTypeNodes);
                var newGroup = [nextDocumentTypeNode];
                remainingDocumentTypeNodes.shift(1);
                var matchingNodes = _lodash2.default.filter(remainingDocumentTypeNodes, function (otherDocumentTypeNode) {
                    return (0, _nodeEquivalence.areChildNodesEquivalent)(nextDocumentTypeNode, otherDocumentTypeNode);
                });
                newGroup.push.apply(newGroup, (0, _toConsumableArray3.default)(matchingNodes));
                remainingDocumentTypeNodes = _lodash2.default.difference(remainingDocumentTypeNodes, matchingNodes);
                groupings.set(_lodash2.default.clone(nextDocumentTypeNode.children), newGroup);
            };

            while (remainingDocumentTypeNodes.length > 0) {
                _loop2();
            }
            return groupings;
        }
    }]);
    return DocumentTypeOptimizerVisitor;
}(_QueryNodeVisitor3.default);

exports.default = DocumentTypeOptimizerVisitor;